import { FulfillmentOrderAddressSchema } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { consolidationCartonLabelDraftSchema } from "@redotech/redo-fulfillment-operations-common/consolidation-carton-label";
import * as z from "zod";
import { consolidationCartonLabelInputSchema } from "./consolidation-carton-label-common";

export const saveConsolidationCartonLabelDraft = {
  name: "saveConsolidationCartonLabelDraft" as const,
  mutates: true,
  input: consolidationCartonLabelInputSchema.extend(
    consolidationCartonLabelDraftSchema.shape,
  ),
  output: z.object({
    destination: FulfillmentOrderAddressSchema,
    draftFingerprint: z.string().min(1),
    origin: FulfillmentOrderAddressSchema,
  }),
};
